import React from 'react';
import {
  loginWithGoogleEventEmitter,
  loginEventEmitter,
} from 'components/Login/Login';
import { setSessionStorage } from 'utils/storageUtils';
import s from './LoginPrompt.scss';

const LoginPrompt = ({
  closePopup,
  loginCloasedGame,
  pagePart,
  // calledFromGame,
}) => {
  const loginWithGoogle = () => {
    if (!pagePart) {
      closePopup();
    }
    setSessionStorage('ga4EventTypeValue', 'previous_game');
    loginWithGoogleEventEmitter();
  };

  const showEmailLogin = () => {
    if (!pagePart) {
      closePopup();
    }
    const ga4EventTypeValue = 'previous_game';
    loginEventEmitter(undefined, {}, undefined, ga4EventTypeValue);
  };

  return (
    <div className={pagePart ? `${s.wrap_poll} ${s.wrap_page}` : s.wrap_poll}>
      <div
        className={`${s.poll_withoutLogin} ${
          s.poll_without_success
        } poll_withoutLogin  `}
      >
        <div className={s.inner}>
          <h4>
            {loginCloasedGame
              ? 'Login to play this game'
              : 'Login to unlock leaderboard'}
          </h4>
          <p>
            {loginCloasedGame
              ? 'Continue with a quick login to access this game'
              : 'Continue with a quick login to access leaderboard'}
          </p>
          <div className={s.login_options}>
            <div className={s.loginOptionWrap}>
              <button
                className={s.google}
                title="Google"
                onClick={loginWithGoogle}
              >
                <i /> Continue with Google
              </button>
            </div>
            <span>
              <i>or </i>
            </span>
            <div className={s.loginOptionWrap}>
              <div className={s.disclaimer_btn}>
                <button className={s.submit} onClick={showEmailLogin}>
                  Login with Email or Mobile
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPrompt;
